import { render, staticRenderFns } from "./BuckCareers.vue?vue&type=template&id=7b703641&"
import script from "./BuckCareers.vue?vue&type=script&lang=ts&"
export * from "./BuckCareers.vue?vue&type=script&lang=ts&"
import style0 from "./BuckCareers.vue?vue&type=style&index=0&id=7b703641&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports